import React from 'react'
import { Typography, Box } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DealerSignupSection from 'components/DealerSignupSection'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const TermsConditionsPage = () => {
  const { t } = useTranslation()
  return (
    <Box>
      <FixedWidthContainer>
        <SectionHeader title={t('termsConditions.title')} />

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.readCarefully')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.intro')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.claimsTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.unconcealedDamage')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.concealedDamage')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.pleaseLetUsKnow')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.copyrightTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.copyrightContent')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.trademarksTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.trademarksContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.warrantyDisclaimerTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.warrantyDisclaimerContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.limitationTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.limitationContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.typographicalTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.typographicalContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.termsTerminationTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.termsTerminationContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.noticeTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.noticeContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.miscellaneousTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.miscellaneousContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.useOfSiteTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.useOfSiteContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.participationTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.participationContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.indemnificationTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('termsConditions.indemnificationContent')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('termsConditions.thirdPartyTitle')}
        </Typography>

        <Typography
          variant='body1'
          sx={{ mb: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('termsConditions.thirdPartyContent')}
        </Typography>
      </FixedWidthContainer>
      <DealerSignupSection />
    </Box>
  )
}

export default TermsConditionsPage
